import React, {Component} from 'react';
import axios from 'axios';
import cookie from 'react-cookies';
import Login from './Login';
import Signup from './Signup';
import ForgotPwd from './ForgotPwd';
import Setting from './Setting';
import ChangePwd from './ChangePwd';
import ResetPwd from './ResetPwd';
import Modal from "react-bootstrap/Modal";
import Select from 'react-select'
import 'bootstrap/dist/css/bootstrap.min.css';
import AddAsset from './AddAsset';
import Autocomplete from "./Autocomplete";
import {Redirect} from 'react-router';

import Buysubscription from './Buysubscription';
import Buyxchange from './Buyxchange';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

const stripePromise = loadStripe("pk_test_370qjoE9grb7T4nk8CH6kZyx00qUhUOKLR");

class Header extends Component{
	constructor(props){
		super(props);

		this.state = {
			showLoginPopup: 		false,
			showSignupPopup: 		false,
			showForgotPwdPopup: 	false,
			showSettingPopup: 		false,
			showChangePwdPopup: 	false,
			showResetPwdPopup: 		false,
			showLanguagePopup: 		false,
			imageUrl: 				null,
			showFilterPopup: 		false,
			showRequestGamePopup:   false,
			selectedGameType:	   	null,
			gameTitle: 				'',
			showAddAssetPopup: 		false,
			showUserPopup: 			false,
			assetList:				[],
			characterList:			[],
			gameList:				[],
			userList:				[],
			postLabelList:			[],
			selectedPostType:		null,
			selectedPostId:			0,
			redirect: 				null,
			searchKeyword: 			'',
			showBuySubscription: 	false,
			showBuyXchange: 		false,
			showAlert: 				false,
			currentEmail: 			'',
			alertMessage: 			''
		};

		if ( localStorage.getItem('Language') ) {
			this.state = {
				language: localStorage.getItem('Language').toLowerCase(),
				flag_lang:	'/assets/images/flags/flag_' + localStorage.getItem('Language').toLowerCase() + '.png'
			};
		} else {
			this.state = {
				language: "english",
				flag_lang:	"/assets/images/flags/flag_english.png"
			};
		}

		this.setWrapperRefLanguagePopup = this.setWrapperRefLanguagePopup.bind(this);
		this.setWrapperRefUserPopup = this.setWrapperRefUserPopup.bind(this);
		this.setWrapperRefSearchPopup = this.setWrapperRefSearchPopup.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.gameTitleChangeHandler = this.gameTitleChangeHandler.bind(this);
	}
	
	componentWillMount(){
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);

		this.setUserName();	
		this.checkNewPwd(window.location.search);
		this.getGameTypeList();
		this.getAssetList();
	}

	getAssetList() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getTopAssetList')
			.then(response => {
				if ( response.status === 200 ) {
					var temp = [];
					for (var i=0; i<response.data.length; i++) {
						temp.push(response.data[i].name);
					}

					this.setState({
						assetList: response.data,
						postLabelList: temp
					}, function(){
						this.getGameList();
						this.getCharacterList();
						this.getUserList();
					});
				}
			})
	}

	getGameList() {		
		axios.get(window.$backend_url + '/getActiveGameList')
			.then(response => {				
				if ( response.status === 200 ) {
					this.setState({
						gameList: response.data
					})

					var temp = this.state.postLabelList;

					for (var i=0; i<response.data.length; i++) {
						temp.push(response.data[i].name);
					}

					this.setState({
						postLabelList: temp
					})
				}
			})
	}

	getCharacterList() {
		axios.get(window.$backend_url + '/getCharacterList')
			.then(response => {				
				if ( response.status === 200 ) {
					this.setState({
						characterList: response.data
					})

					var temp = this.state.postLabelList;

					for (var i=0; i<response.data.length; i++) {
						temp.push(response.data[i].name);
					}

					this.setState({
						postLabelList: temp
					})
				}
			})
	}

	getUserList() {
		axios.get(window.$backend_url + '/getUserList')
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						userList: response.data
					})

					var temp = this.state.postLabelList;

					for (var i=0; i<response.data.length; i++) {
						temp.push(response.data[i].name);
					}

					this.setState({
						postLabelList: temp
					})
				}
			})
	}

	searchPost(val) {
		var filteredOptions = this.checkAsset(val, this.state.assetList);
		this.setState({
			searchKeyword: val
		})

		if (filteredOptions.length) {
			this.setState({
				selectedPostType: "Asset",
				selectedPostId: filteredOptions[0].id
			})
		} else {
			filteredOptions = this.checkAsset(val, this.state.characterList);

			if (filteredOptions.length) {
				this.setState({
					selectedPostType: "Character",
					selectedPostId: filteredOptions[0].id
				})
			} else {
				filteredOptions = this.checkAsset(val, this.state.gameList);

				if (filteredOptions.length) {
					this.setState({
						selectedPostType: "Game",
						selectedPostId: filteredOptions[0].id
					})
				} else {
					filteredOptions = this.checkAsset(val, this.state.userList);

					if (filteredOptions.length) {
						this.setState({
							selectedPostType: "User",
							selectedPostId: filteredOptions[0].id
						})
					} else {
						this.setState({
							selectedPostType: null,
							selectedPostId: 0
						})
					}
				}
			}
		}
	}

	goPostPage() {
		switch (this.state.selectedPostType) {
			case 'Asset':
				localStorage.setItem('assetId', this.state.selectedPostId);
				localStorage.removeItem('assetImage');
				localStorage.removeItem('assetOwnerId');
				localStorage.removeItem('assetOwnerName');
				localStorage.removeItem('assetOwnerAvatar');
				if (window.location.pathname.indexOf('/assetDescription') == 0) {
					window.location.reload();
				} else {
					// this.setState({ redirect: "/assetDescription" });
					this.props.history.push('/assetDescription');
				}
				break;
			case 'Character':
				localStorage.setItem('characterId', this.state.selectedPostId);
				localStorage.removeItem('characterImage');
				if (window.location.pathname.indexOf('/characterDescription') == 0) {
					window.location.reload();
				} else {
					// this.setState({ redirect: "/characterDescription" });
					this.props.history.push('/characterDescription');
				}
				break;
			case 'Game':
				localStorage.setItem('gameId', this.state.selectedPostId);
				if (window.location.pathname.indexOf('/assets') == 0) {
					window.location.reload();
				} else {
					// this.setState({ redirect: "/assets" });
					this.props.history.push('/assets');
				}
				break;
			case 'User':
				localStorage.setItem('userId', this.state.selectedPostId);
				if (window.location.pathname.indexOf('/profile') == 0) {
					window.location.reload();
				} else {
					// this.setState({ redirect: "/profile" });
					this.props.history.push('/profile');
				}
				break;
			default:
				this.setState({
					showFilterPopup: true
				})
		}
	}

	checkAsset(val, list) {
		var filteredOptions = [];
		if (list) {
			filteredOptions = list.filter(
				(item) =>
				item.name  == val
			);
		}

		return filteredOptions;			
	}

	setWrapperRefLanguagePopup(node) {
		this.languagePopup = node;
	}

	setWrapperRefUserPopup(node) {
		this.userPopup = node;
	}

	setWrapperRefSearchPopup(node) {
		this.searchPopup = node;
	}

	handleClickOutside(event) {
		if (this.languagePopup && !this.languagePopup.contains(event.target)) {
			this.setState({
				showLanguagePopup: false
			})
		}

		if (this.userPopup && !this.userPopup.contains(event.target)) {
			this.setState({
				showUserPopup: false
			})
		}

		if (this.searchPopup && !this.searchPopup.contains(event.target)) {
			this.setState({
				showFilterPopup: false
			})
		}
	}

	toggleAddAssetPopup() {
		this.setState({  
			showAddAssetPopup: !this.state.showAddAssetPopup  
		});
	}

	getGameTypeList() {
		axios.defaults.withCredentials = true;
		
		axios.get(window.$backend_url + '/getGameTypes')
			.then(response => {
				if ( response.status === 200 ) {
					var gameTypeList = [];

					for (var i=0; i<response.data.length; i++) {
						gameTypeList.push({ value: response.data[i].id, label: response.data[i].type });
					}

					this.setState({
						gameTypeList: gameTypeList
					});
				}
			})
	}

	changeGameTypeHandler = selectedGameType => {
		this.setState({ 
			selectedGameType: selectedGameType
		})
	}

	checkNewPwd(code) {
		if ( code ) {
			const codeData = {
				code : code
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/checkNewPwdCode',codeData)
				.then(response => {
					if(response.status === 200){
						this.setState({
							showResetPwdPopup: true
						})
					}
				})
				.catch(error => {
				})
		}
	}

	setUserName() {
		if ( cookie.load('cookieId') ) {
			const userdata = {
				userid: cookie.load('cookieId')
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/getUserInfo',userdata)
				.then(response => {
					if(response.status === 200){
						this.setState({
							username : response.data[0].first_name + " " + response.data[0].last_name
						})

						localStorage.setItem('userRole', response.data[0].role);

						this.props.checkLogin();
					}
				})

			this.setUserAvatar();
		} else {
			this.props.checkLogin();
		}
	}	

	setUserAvatar() {
		const userdata = {
			userid: cookie.load('cookieId')
		}		

		axios.defaults.withCredentials = true;
		
		axios.post(window.$backend_url + '/getUserAvatar', userdata)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						imageUrl: response.data
					})
				} else {
					this.setState({
						imageUrl: ''
					})
				}

			})
			.catch(error => {
				this.setState({
					imageUrl: ''
				})

			})
	}

	toggleLoginPopup() {
		this.setState({  
			showLoginPopup: !this.state.showLoginPopup  
		});
	}

	showSignUpForUpdatePopup(email) {
		this.setState({
			currentEmail: email
		}, function(){
			this.toggleSignupPopup();
		});
	}

	toggleSignupPopup() {
		this.setState({
			showSignupPopup: !this.state.showSignupPopup
		});
	}

	finishSignUp() {
		this.setState({
			showSignupPopup: false,
			alertMessage: this.props.dataLanguage['account_pending']
		});

		this.setAlertMessage(this.props.dataLanguage['account_pending']);
	}

	setAlertMessage(message) {
		this.setState({
			alertMessage: message
		});

		this.showAlert();
	}

	showAlert() {
		this.setState({
			showAlert: true
		});

		setTimeout(() => {
			this.setState({
				showAlert: false
			});
		}, 6000);
	}

	closeAlert() {
		this.setState({
			showAlert: false
		})
	}

	toggleForgotPwdPopup() {
		this.setState({  
			showForgotPwdPopup: !this.state.showForgotPwdPopup  
		});
	}

	toggleSettingPopup() {
		if ( this.state.showSettingPopup ) {
			this.setUserName();
		}

		this.setState({  
			showSettingPopup: !this.state.showSettingPopup  
		});
	}

	toggleChangePwdPopup() {
		this.setState({  
			showChangePwdPopup: !this.state.showChangePwdPopup  
		});
	}

	toggleResetPwdPopup() {
		this.setState({  
			showResetPwdPopup: !this.state.showResetPwdPopup  
		});
	}

	toggleLanguagePopup() {
		if (this.props.preview == false) {
			this.setState({
				showLanguagePopup: false
			});
		} else {
			this.setState({
				showLanguagePopup: !this.state.showLanguagePopup
			});
		}
	}

	toggleUserPopup() {
		this.setState({
			showUserPopup: !this.state.showUserPopup
		});
	}

	toggleFilterPopup() {
		this.setState({
			showFilterPopup: !this.state.showFilterPopup
		});
	}

	toggleRequestGamePopup() {
		this.setState({
			showRequestGamePopup: !this.state.showRequestGamePopup
		})
	}

	switchPopupChangePwd() {
		this.setState({  
			showSettingPopup: false,
			showChangePwdPopup: true
		});
	}	

	switchPopupLogin() {
		this.setState({
			showResetPwdPopup: false,
			showSignupPopup: false,
			showLoginPopup: true
		});
	}

	switchPopupSignup() {
		this.setState({  
			showSignupPopup: true,
			showLoginPopup: false,
			showForgotPwdPopup: false
		});
	}

	switchPopupForgotPwd() {
		this.setState({  
			showSignupPopup: false,
			showLoginPopup: false,
			showForgotPwdPopup: true
		});
	}

	logout = () => {
		cookie.remove('cookieId', {path: '/'});
		// window.location = "/";
		
		localStorage.removeItem('countryId');
		this.props.checkLogin();
	}

	setLanguage(lang) {
		localStorage.setItem('Language', lang);
		this.props.setLanguage(lang);

		this.setState({
			language: lang.toLowerCase(),
			flag_lang: '/assets/images/flags/flag_' + lang.toLowerCase() + '.png',
		});
	}

	gameTitleChangeHandler(e) {
		this.setState({gameTitle: e.target.value});
	}

	sendRequestGame() {
		if (this.state.gameTitle && this.state.selectedGameType) {
			const gameData = {
				userId: cookie.load('cookieId'),
				title : this.state.gameTitle,
				gameType: this.state.selectedGameType
			}
			
			axios.defaults.withCredentials = true;
			
			axios.post(window.$backend_url + '/sendRequestGame', gameData)
				.then(response => {
					if(response.status === 200){
						this.setState({
							showRequestGamePopup: false
						})
					}
				})
				.catch(error => {
					this.setState({
						showRequestGamePopup: false
					})
				})
		}
	}

	closeBuySubscription() {
		this.setUserName();
		this.toggleBuySubscription();
	}

	toggleBuySubscription() {
		this.setState({  
			showBuySubscription: !this.state.showBuySubscription  
		});
	}

	closeBuyXchange() {
		this.setUserName();
		this.toggleBuyXchange();
	}

	toggleBuyXchange() {
		this.setState({  
			showBuyXchange: !this.state.showBuyXchange  
		});
	}

	render(){
		if (this.state.redirect) {
			return <Redirect to={this.state.redirect} />
		}

		const customStyles = {
			control: styles => ({ 
				...styles,
				backgroundColor: '#ffffff',
				border: 'solid 3px #ffd33f',
				borderRadius: '20px',
				paddingLeft: '5px',
				paddingRight: '5px',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					border: 'solid 3px #ffd33f',
					color: 'gray',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					border: 'solid 3px #ffd33f',
					color: 'gray',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:placeholder": {
					color: '#64541c'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '5px 10px',
					size: 5,
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "black",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}

		return (
			<div>
				<div ref="alertDiv" className={ this.state.showAlert ? "alert_message" : "alert_message up"}>
					<div className="alert_message_inner">
						<p className="text-yellow">{ this.state.alertMessage }</p>
						<button onClick={this.closeAlert.bind(this)}>×</button>
					</div>
				</div>
				<header className="hero-digit">
					<div className="logo">
						<a href="/"><img alt="logo" src="/assets/images/logo.png" /></a>
					</div>
					<div className="right-nav">
						<div className="right-up">
							{cookie.load('cookieId') ? (
									<ul>
									<li><button onClick={this.logout.bind(this)}>{this.props.dataLanguage['logout']}</button></li>
									</ul>
								) : (
									<ul>
									<li><button onClick={this.toggleLoginPopup.bind(this)}>{this.props.dataLanguage['login']}</button></li>
									<li><button onClick={this.toggleSignupPopup.bind(this)}>{this.props.dataLanguage['signup']}</button></li>
									</ul>
								)
							}
						</div>
						<div className="right-down">
							{cookie.load('cookieId') ?
								<div ref={this.setWrapperRefUserPopup} className="profile dropdown" onClick={this.toggleUserPopup.bind(this)}>
									<div className="profile-img">
										<div className="avatar-container">
											<img alt="" src={ this.state.imageUrl } />
										</div>
										<span className="status hidden">3</span>
										<span className="online active hidden"></span>
									</div>
									<span className="username">{this.state.username}</span><img alt="" className="arrow-down" src="/assets/images/arrow-down.png" />
									{ this.state.showUserPopup ?
										<ul className="">
											<li><a onClick={this.toggleBuySubscription.bind(this)}>{this.props.dataLanguage['buy_subscription']}</a></li>
											<li><a onClick={this.toggleBuyXchange.bind(this)}>{this.props.dataLanguage['giftXchange']}</a></li>
											<li><a onClick={this.logout.bind(this)}>{this.props.dataLanguage['logout']}</a></li>
										</ul>
									: null }
								</div>
								: null
							}
							<div ref={this.setWrapperRefLanguagePopup} className={`language dropdown ${this.state.showLanguagePopup ? "active" : ""}`} onClick={this.toggleLanguagePopup.bind(this)}>
								<img className="lan_flag" alt="" src={this.state.flag_lang} /> {this.props.dataLanguage[this.state.language]} <img alt="" className="arrow-down" src="/assets/images/arrow-down.png" />

								{this.state.showLanguagePopup ?  
									<ul className="active">
										<li><button onClick={() => this.setLanguage("Chinese")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_chinese.png" /><span className="language">{this.props.dataLanguage['chinese']}</span></button></li>
										<li><button onClick={() => this.setLanguage("English")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_english.png" /><span className="language">{this.props.dataLanguage['english']}</span></button></li>
										<li><button onClick={() => this.setLanguage("Japanese")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_japanese.png" /><span className="language">{this.props.dataLanguage['japanese']}</span></button></li>
										<li><button onClick={() => this.setLanguage("Korean")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_korean.png" /><span className="language">{this.props.dataLanguage['korean']}</span></button></li>
										<li><button onClick={() => this.setLanguage("German")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_german.png" /><span className="language">{this.props.dataLanguage['german']}</span></button></li>
										<li><button onClick={() => this.setLanguage("French")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_french.png" /><span className="language">{this.props.dataLanguage['french']}</span></button></li>
										<li><button onClick={() => this.setLanguage("Spanish")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_spanish.png" /><span className="language">{this.props.dataLanguage['spanish']}</span></button></li>
										<li><button onClick={() => this.setLanguage("Italian")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_italian.png" /><span className="language">{this.props.dataLanguage['italian']}</span></button></li>
										<li><button onClick={() => this.setLanguage("Russian")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_russian.png" /><span className="language">{this.props.dataLanguage['russian']}</span></button></li>
										<li><button onClick={() => this.setLanguage("Portuguese")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_portuguese.png" /><span className="language">{this.props.dataLanguage['portuguese']}</span></button></li>
										<li><button onClick={() => this.setLanguage("Hindi")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_hindi.png" /><span className="language">{this.props.dataLanguage['hindi']}</span></button></li>
										<li><button onClick={() => this.setLanguage("Arabic")} className="btn_set_language"><img alt="" src="/assets/images/flags/flag_arabic.png" /><span className="language">{this.props.dataLanguage['arabic']}</span></button></li>
									</ul>
								: null  
								}
							</div>
							{cookie.load('cookieId') ?
								<button className="setting" onClick={this.toggleSettingPopup.bind(this)}><img alt="" src="/assets/images/setting.png" /></button>
								: null
							}
						</div>
					</div>
					<div className="search-container">
						<div>
							<div className="custom_autocomplete post_search">
								{ this.state.postLabelList ?
									<Autocomplete
										options = {this.state.postLabelList}
										changeValue = {this.searchPost.bind(this)}
										placeholder = {this.props.dataLanguage['search']}
									/>
								: null }
							</div>
							<div className="filter" onClick={this.toggleFilterPopup.bind(this)}><p><img alt="" src="/assets/images/drop-down.png" />{this.props.dataLanguage['filter']}</p></div>
							<button type="submit" onClick={this.goPostPage.bind(this)}><img alt="" src="/assets/images/search-icon.png" /></button>
						</div>
						{ this.state.showFilterPopup ?
							<div ref={this.setWrapperRefSearchPopup} className="filter-dropdown">
								{ cookie.load('cookieId') ?
									<button onClick={this.toggleAddAssetPopup.bind(this)}>{this.props.dataLanguage['add_asset']}</button>
								: null }
								<button onClick={this.toggleRequestGamePopup.bind(this)}>{this.props.dataLanguage['request_game']}</button>
								{ this.state.selectedPostType == null && this.state.searchKeyword ?
									<p>{this.props.dataLanguage['search_msg']}</p>
								: null }

								{ this.state.showRequestGamePopup ?
									<div className="select-box">
										<div className="select-box-field">
											<input name="Title" placeholder="Title" type="text" value={this.state.gameTitle} onChange={this.gameTitleChangeHandler} />
										</div>
										<div className="select-box-field">
											<div className="select-dropdown">
												<Select id="Genre" styles={customStyles} options={this.state.gameTypeList} onChange={this.changeGameTypeHandler} value={this.state.selectedGameType} placeholder={this.props.dataLanguage['genre']} />
											</div>
											<button onClick={this.sendRequestGame.bind(this)}>{this.props.dataLanguage['submit']}</button>
										</div>
									</div>
								: null }
							</div>
						: null }
					</div>
				</header>
				{this.state.showLoginPopup ?  
					<Modal show={this.state.showLoginPopup} onHide={this.toggleLoginPopup.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Login dataLanguage={this.props.dataLanguage} closeLoginPopup={this.toggleLoginPopup.bind(this)} switchPopupSignup={this.switchPopupSignup.bind(this)} switchPopupForgotPwd={this.switchPopupForgotPwd.bind(this)} setUserName={this.setUserName.bind(this)} />
					</Modal>
				: null  
				}
				{this.state.showSignupPopup ?  
					<Modal show={this.state.showSignupPopup} onHide={this.toggleSignupPopup.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Signup dataLanguage={this.props.dataLanguage} finishSignUp={this.finishSignUp.bind(this)} closeSignupPopup={this.toggleSignupPopup.bind(this)} switchPopupLogin={this.switchPopupLogin.bind(this)} currentEmail={this.state.currentEmail} />
					</Modal>
				: null
				}
				{this.state.showForgotPwdPopup ?  
					<Modal show={this.state.showForgotPwdPopup} onHide={this.toggleForgotPwdPopup.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<ForgotPwd dataLanguage={this.props.dataLanguage} closeForgotPwdPopup={this.toggleForgotPwdPopup.bind(this)} switchPopupSignup={this.switchPopupSignup.bind(this)} />
					</Modal>
				: null  
				}
				{this.state.showSettingPopup ?  
					<Modal show={this.state.showSettingPopup} onHide={this.toggleSettingPopup.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Setting dataLanguage={this.props.dataLanguage} closeSettingPopup={this.toggleSettingPopup.bind(this)} switchPopupChangePwd={this.switchPopupChangePwd.bind(this)} imageUrl={this.state.imageUrl} />
					</Modal>
				: null  
				}

				{this.state.showChangePwdPopup ?  
					<Modal show={this.state.showChangePwdPopup} onHide={this.toggleChangePwdPopup.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<ChangePwd dataLanguage={this.props.dataLanguage} closeSettingPopup={this.toggleChangePwdPopup.bind(this)} closeChangePwdPopup={this.toggleChangePwdPopup.bind(this)} />
					</Modal>
				: null  
				}

				{this.state.showResetPwdPopup ?  
					<Modal show={this.state.showResetPwdPopup} onHide={this.toggleResetPwdPopup.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<ResetPwd dataLanguage={this.props.dataLanguage} switchPopupLogin={this.switchPopupLogin.bind(this)} closeResetPwdPopup={this.toggleResetPwdPopup.bind(this)} />
					</Modal>
				: null  
				}
				{this.state.showAddAssetPopup ?  
					<Modal show={this.state.showAddAssetPopup} onHide={this.toggleAddAssetPopup.bind(this)} animation={false} className="largeModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<AddAsset dataLanguage={this.props.dataLanguage} closeAddAssetPopup={this.toggleAddAssetPopup.bind(this)} gameList={this.state.gameList} history={this.props.history} />
					</Modal>
				: null  
				}
				{this.state.showBuySubscription ?  
					<Modal show={this.state.showBuySubscription} onHide={this.toggleBuySubscription.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Elements stripe={stripePromise}>
							<Buysubscription dataLanguage={this.props.dataLanguage} closeBuySubscription={this.closeBuySubscription.bind(this)} />
						</Elements>
					</Modal>
				: null  
				}
				{this.state.showBuyXchange ?  
					<Modal show={this.state.showBuyXchange} onHide={this.toggleBuyXchange.bind(this)} animation={false}>
						<Modal.Header closeButton>
						</Modal.Header>
						<Elements stripe={stripePromise}>
							<Buyxchange dataLanguage={this.props.dataLanguage} closeBuyXchange={this.closeBuyXchange.bind(this)} />
						</Elements>
					</Modal>
				: null  
				}
			</div>
		);
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js